/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
import React, { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { ptBR } from '@mui/material/locale';
import { get } from 'lodash';
import { toast } from 'react-toastify';
import { Link, useParams, useNavigate } from 'react-router-dom';
import {
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  Tooltip,
  Button,
  TextField,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { FaEdit, FaWindowClose, FaExclamation } from 'react-icons/fa';
import axios from '../../services/axios';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import Loading from '../../components/Loading';
import * as colors from '../../config/colors';

export default function Cadastro() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [nome, setNome] = useState('');
  const [detalhes, setDetalhes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const theme = useTheme();

  const textData = 'Tipo de Despesa / Detalhes';
  // const tableData = 'motorista';
  const tableDatas = 'tipodespesas';

  async function getData() {
    try {
      setIsLoading(true);

      const { data } = await axios.get(`/${tableDatas}/${id}`);
      setNome(data.nome);
      const children = get(data, 'TipoDespesaDetalhes', '');
      setDetalhes(children);

      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const status = get(err, 'response.status', 0);
      const errors = get(err, 'response.data.errors', []);

      if (status === 400) errors.map((error) => toast.error(error));
      navigate(`/${tableDatas}`);
    }
  }
  useEffect(() => {
    if (!id) {
      return;
    }
    getData();
  }, []);

  const handleDeleteAsk = (id1) => {
    setDeleteConfirmId(id1);
  };

  const handleDelete = async (e, idchildren, index) => {
    e.persist();

    try {
      await axios.delete(`/tipodespesadetalhes/${idchildren}`);
      const novosDados = [...detalhes];
      novosDados.splice(index, 1);
      setDetalhes(novosDados);
      toast.success('Registro excluído com sucesso!');
    } catch (err) {
      const status = get(err, 'response.status', 0);
      if (status === 401) {
        toast.error('Você precisa fazer login como Administrador!');
      } else if (status === 400) {
        toast.error(
          'Registro não pode ser excluído: Relacionamento entre tabelas!'
        );
      } else {
        toast.error(`Ocorreu um erro ao excluir registro!`);
      }
    } finally {
      setDeleteConfirmId(null);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
      },
      {
        accessorKey: 'Detalhe.nome',
        header: 'Detalhe',
        size: 80,
      },
    ],
    []
  );

  return (
    <ContainerGrid>
      <Title>{`${textData}`}</Title>
      <Box sx={{ display: 'flex', marginBottom: '5px' }}>
        <TextField
          value={nome}
          label="Tipo Despesa"
          InputProps={{
            readOnly: true,
          }}
          variant="filled"
          size="small"
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          onClick={() => navigate(`/tipodespesadetalhe/${id}`)}
        >
          <AddIcon size={24} />
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={() => navigate(`/tipodespesas`)}
        >
          Fechar
        </Button>
      </Box>
      <ThemeProvider theme={createTheme(theme, ptBR)}>
        <MaterialReactTable
          localization={MRT_Localization_PT_BR}
          columns={columns}
          data={detalhes}
          initialState={{ density: 'compact' }}
          enableRowActions
          renderRowActions={({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Editar">
                <Link
                  to={`/tipodespesadetalhe/${id}/edit/${row.getValue('id')}`}
                >
                  <FaEdit size={16} />
                </Link>
              </Tooltip>
              <Tooltip arrow placement="right" title="Excluir">
                <div>
                  {deleteConfirmId === row.getValue('id') ? (
                    <FaExclamation
                      size={16}
                      color={colors.errorColor}
                      cursor="pointer"
                      onClick={(e) =>
                        handleDelete(e, row.getValue('id'), row.id)
                      }
                    />
                  ) : (
                    <FaWindowClose
                      size={16}
                      color={colors.primaryColor}
                      cursor="pointer"
                      onClick={() => handleDeleteAsk(row.getValue('id'))}
                    />
                  )}
                </div>
              </Tooltip>
            </Box>
          )}
        />
      </ThemeProvider>
      <Loading isLoading={isLoading} />
    </ContainerGrid>
  );
}
